import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanDeactivate } from '@angular/router';
import { combineLatest, Observable,  } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { MutService } from './mut.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable()
export class MutGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private mutService: MutService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        return combineLatest([
            this.mutService.getMut(this.applicationService.caseId),
            this.mutService.getMutationTypeConfigurations()
        ]).pipe(
            map(() => true)
        );
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.mutService.closeMut();
        return true;
    }
}
